<template>
    <div class="data_container">
        <div class="data_head">{{title}}</div>
        <div class="data_data">{{data}}
            <span class="data_unit">{{unit}}</span>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "dataitem",
        props: ['title', 'data', 'unit']
    }
</script>

<style lang="less" scoped>
    .data_container {
        .w(240);
        .h(180);
        background: rgba(0, 43, 102, 0.04);
        padding: 0 24rem;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        .data_head {
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
        }

        .data_data {
            .h(70);
            font-size: 36rem;
            font-weight: bold;
            color: #0D94FF;

            .data_unit {
                font-size: 18rem;
            }
        }
    }
</style>